import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { BackdropLoader, getBank, Icon, toast } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Button, Link, Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ChangePaymentMethodModal from 'src/components/settings/ChangePaymentMethodModal';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { UpdatePaymentMethodModal } from '../UpdatePaymentMethodModal';
export const PaymentMethod = observer(_ref => {
  var _store$payment$autopa2;
  let canBeModified = _ref.canBeModified,
    changeDefaultEnabled = _ref.changeDefaultEnabled,
    method = _ref.method,
    isBackupMethod = _ref.isBackupMethod,
    assignedProperty = _ref.assignedProperty,
    _ref$isFailed = _ref.isFailed,
    isFailed = _ref$isFailed === void 0 ? false : _ref$isFailed,
    _ref$isNotVerified = _ref.isNotVerified,
    isNotVerified = _ref$isNotVerified === void 0 ? false : _ref$isNotVerified;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    autoPayMethodId = _useState6[0],
    setAutoPayMethodId = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    paymentMethodId = _useState8[0],
    setPaymentMethodId = _useState8[1];
  const setAutopayMethod = async data => {
    const resp = await store.payment.setAutopayMethodAsync.run(data);
    return resp;
  };
  const deletePaymentMethod = async id => {
    const resp = await store.payment.deletePaymentMethodAsync.run(id);
    return resp;
  };
  useEffect(() => {
    if (autoPayMethodId) {
      setIsLoading(true);
      setAutopayMethod({
        paymentMethodId: autoPayMethodId
      }).then(resp => {
        if (resp && resp.isSuccessful) {
          const newDefaultMethod = store.payment.paymentMethods.find(m => m.id === autoPayMethodId);
          store.payment.setAutopayMethodAfterLoad({
            response: _objectSpread({}, newDefaultMethod)
          });
          toast('success', {
            body: ['Default method successfully set']
          }); // ? i18n
          setAutoPayMethodId(null);
        }
      }).finally(() => setIsLoading(false));
    }
  }, [autoPayMethodId]);
  useEffect(() => {
    if (paymentMethodId) {
      setIsLoading(true);
      deletePaymentMethod({
        paymentMethodId
      }).then(resp => {
        if (resp && resp.isSuccessful) {
          store.payment.updatePaymentMethodsAfterDelete({
            paymentMethodId
          });
          toast('success', {
            body: ['Payment method successfully deleted']
          }); // ? i18n
          setPaymentMethodId(null);
          if (!store.payment.paymentMethods.length) {
            store.payment.setMethodAdded(false);
          }
        }
      }).finally(() => setIsLoading(false));
    }
  }, [paymentMethodId]);
  const isAutoPayMethod = () => {
    var _store$payment$autopa;
    return ((_store$payment$autopa = store.payment.autopayMethod) === null || _store$payment$autopa === void 0 ? void 0 : _store$payment$autopa.id) === method.id;
  };
  const handleDelete = () => {
    if (isAutoPayMethod() && store.payment.paymentMethods.length > 1) {
      toast('warning', {
        body: ['You have to choose another default payment method to delete this one'] // ? i18n
      });
    } else {
      setPaymentMethodId(method.id);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, {
    variant: "basic",
    className: isFailed ? classes.declinedPaper : isNotVerified ? classes.notVerifiedPaper : ''
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), isFailed && /*#__PURE__*/React.createElement("div", {
    className: classes.declinedCaption
  }, "Payment Method Failed"), isNotVerified && /*#__PURE__*/React.createElement("div", {
    className: classes.notVerifiedCaption
  }, "Pending verification"), /*#__PURE__*/React.createElement("div", {
    className: classes.paperContent
  }, method.brand && /*#__PURE__*/React.createElement("div", {
    className: classes.method
  }, /*#__PURE__*/React.createElement("img", {
    src: getBank(method.brand).logo,
    width: "76",
    height: "48",
    alt: "bank logo"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.methodDetails
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, getBank(method.brand).title, "\xA0", t('subscriptions.ending_in'), " \u2022\u2022\u2022\u2022\u2006", method.last4), !method.isVerified && method.verificationUrl && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Pending verification - Click", ' ', /*#__PURE__*/React.createElement(Link, {
    href: method.verificationUrl,
    target: "_blank"
  }, "here"), ' ', "to verify"))), canBeModified ? /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, isFailed && /*#__PURE__*/React.createElement(UpdatePaymentMethodModal, {
    id: method.id
  }), !isFailed && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    className: isAutoPayMethod() ? classes.isAutoPay : '',
    onClick: () => {
      if (isAutoPayMethod()) return;
      setAutoPayMethodId(method.id);
    },
    variant: "actionButton",
    'custom-attribute': '296-payment-method'
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.payment.getAutopayMethodAsync.inProgress
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "success"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, isAutoPayMethod() ? t('subscriptions.default_method') : t('subscriptions.set_as_default_method'), ' ')), /*#__PURE__*/React.createElement(Button, {
    onClick: handleDelete,
    disabled: store.payment.paymentMethods.length < 2,
    variant: "actionButton",
    'custom-attribute': '297-payment-method'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('general.remove'))))) : isAutoPayMethod() && /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.isAutoPay,
    variant: "actionButton",
    'custom-attribute': '298-payment-method'
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.payment.getAutopayMethodAsync.inProgress
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "success"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('subscriptions.default_method')))), changeDefaultEnabled && store.payment.paymentMethods.length > 0 && ((_store$payment$autopa2 = store.payment.autopayMethod) === null || _store$payment$autopa2 === void 0 ? void 0 : _store$payment$autopa2.id) && /*#__PURE__*/React.createElement(ChangePaymentMethodModal, {
    isBackupMethod: isBackupMethod
  }))), assignedProperty && assignedProperty.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.accordionWrapper
  }, /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isOpen
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "allocation-content",
    id: "allocation-header",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    }),
    onClick: () => setIsOpen(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "View list of assigned properties"))), /*#__PURE__*/React.createElement(AccordionDetails, {
    className: classes.accordionDetails
  }, assignedProperty.map((item, i) => /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    key: i
  }, item)))))));
});